export interface Column {
  id: 'Name' | 'updated' | 'size' | 'actions';
  label: string;
  minWidth?: number;
  align?: 'center';
  format?: (value: number) => string;
}

export type ModalState = {
  deleteModalOpen: boolean;
  renameModalOpen: boolean;
  uploadModalOpen?: boolean;
};

export enum actions {
  openDeleteModal = 'OPEN_DELETE_MODAL',
  closeDeleteModal = 'CLOSE_DELETE_MODAL',
  openRenameModal = 'OPEN_RENAME_MODAL',
  closeRenameModal = 'CLOSE_RENAME_MODAL',
  openUploadModal = 'OPEN_UPLOAD_MODAL',
  closeUploadModal = 'CLOSE_UPLOAD_MODAL',
}

export type ModalAction =
  | { type: actions.openDeleteModal }
  | { type: actions.closeDeleteModal }
  | { type: actions.openRenameModal }
  | { type: actions.closeRenameModal }
  | { type: actions.openUploadModal }
  | { type: actions.closeUploadModal };

export type ModalDispatch = (action: ModalAction) => void;
